import { Toast } from '@roo/roo';
import axios from 'axios';

if (process.env.NODE_ENV === 'development') {
  axios.defaults.baseURL = '/api/greentech/c';
} else if (process.env.NODE_ENV === 'debug') {
  axios.defaults.baseURL = '/api/greentech/c';
} else if (process.env.NODE_ENV === 'production') {
  axios.defaults.baseURL = '/api/greentech/c';
}

// 请求超时时间
axios.defaults.timeout = 10000;
// post请求头
// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    if (process.env.SWIMLANE) {
      config.headers['x-shepherd-swimlane'] = process.env.SWIMLANE;
    }
    return config;
  },
  (error) => Promise.error(error),
);

axios.defaults.withCredentials = true;
// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是200的情况
  (error) => {
    // TODO： 这里的toast之前咋都没声明。。。
    if (error.response?.status) {
      switch (error.response.status) {
        // 401: 未登录
        case 401:
          break;
        case 404:
          Toast({
            message: '网络请求不存在',
          });
          break;
        // 其他错误，直接抛出错误提示
        default:
          Toast({
            message: '网络出错，请检查',
          });
      }
      return Promise.reject(error.response);
    }
  },
);
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params, config = { dontPanic: false }) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params,
      })
      .then((res) => {
        if (res) {
          if (res.data?.code === 0) {
            resolve(res.data?.data);
            return;
          }
          if (res.data?.status?.code === 0 || res.data?.code === 0) {
            resolve(res.data.data);
          } else {
            // TODO: 这里需要额外确认下：是否需要全局的请求错误toast提示？
            let message = res.data?.status?.msg || res.data?.msg || res.data?.message || '接口错误，请稍后再试';
            if (!config.dontPanic) {
              if (res.data?.code === 50103) {
                message = '请登录';
              }
              Toast.open({
                title: message,
                position: 'topCenter',
                duration: 5000,
                status: 'fail',
              });
            }
            reject(message);
          }
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params, config = { dontPanic: false }) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, { ...params })
      .then((res) => {
        if (res.data?.code === 0) {
          return resolve(res.data?.data);
        }
        if (res.data?.status?.code === 0 || res.data?.code === 0) {
          resolve(res.data.data);
        } else {
          const message = res.data?.status?.msg || res.data?.msg || res.data?.message || '接口错误，请稍后再试';
          if (!config.dontPanic) {
            Toast.open({
              title: message,
              position: 'topCenter',
              duration: 5000,
              status: 'fail',
            });
          }
          reject(message);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export { axios };
